import {
  type EditObjectDraftRevision,
  KyrgyzstanEditObjectApi,
} from 'shared/api/kyrgyzstan/edit-object'

const getCreatedRevisionDraft = async (
  sourceId: string,
  signal: AbortSignal,
  createRevision: (
    sourceId: string,
    signal?: AbortSignal,
  ) => ReturnType<typeof KyrgyzstanEditObjectApi.createObjectDraftRevision>,
): Promise<EditObjectDraftRevision> => {
  const { data: createDraftResponse } = await createRevision(sourceId, signal)
  const revisionDraftId = createDraftResponse.data.id
  const { data: draftResponse } =
    await KyrgyzstanEditObjectApi.getDraftRevision(revisionDraftId, signal)

  return draftResponse.data
}

export const loadEditObjectRevisionByObjectId = async (
  objectId: string,
  currentObjectId: string | null,
  currentDraftId: string | null,
  signal: AbortSignal,
): Promise<EditObjectDraftRevision> => {
  if (currentObjectId !== objectId || !currentDraftId) {
    return getCreatedRevisionDraft(
      objectId,
      signal,
      KyrgyzstanEditObjectApi.createObjectDraftRevision,
    )
  }

  const { data: draftResponse } =
    await KyrgyzstanEditObjectApi.getDraftRevision(currentDraftId, signal)

  return draftResponse.data
}

export const loadRejectedObjectRevisionByDraftId = async (
  sourceDraftId: string,
  currentSourceDraftId: string | null,
  currentDraftId: string | null,
  signal: AbortSignal,
): Promise<EditObjectDraftRevision> => {
  if (currentSourceDraftId !== sourceDraftId || !currentDraftId) {
    return getCreatedRevisionDraft(
      sourceDraftId,
      signal,
      KyrgyzstanEditObjectApi.createRejectedDraftRevision,
    )
  }

  const { data: draftResponse } =
    await KyrgyzstanEditObjectApi.getDraftRevision(currentDraftId, signal)

  return draftResponse.data
}
